import { Flex, Grid } from '@chakra-ui/react'
import styled, { css } from 'styled-components'

interface ISkillAnswerProps {
  isSelected?: boolean
}

interface iProps {
  activeResponsive: boolean
}

export const SectionAssociados = styled.div`
border-radius: 0.25rem;
min-width: 46rem;
min-height: 4.5rem;
width: 100%;
border: 1px solid var(--c6);
box-sizing: border-box;
padding: .5rem;
margin-bottom: .5rem;

h4{
    font-weight: 700;
}
`

export const HeaderSection = styled(Flex)`
justify-content: space-between;
align-items: center;
margin-bottom: .325rem;
`

export const SectionBody = styled.div`
display: grid;
grid-template-columns: repeat(4,1fr);
gap: .25rem .5rem;
`

export const Titulo = styled.h2`
font-family: 'Poppins';
font-weight: 500;
font-size: 1.25rem;
`

export const GridContainer = styled(Grid)<iProps>`
  display: grid;
  height: 100%;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: center;

  ${props => props.activeResponsive ? '@media (min-width: 1599px) { grid-template-columns: 1fr 1rem 1fr; }' : ''}
`

export const CardPDI = styled.div<{width?: string}>`
display: flex;
align-items: center;
width: 20rem;

${({ width }) => width && `
    width:${width};
  `}
`

export const PDIText = styled.div`
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  padding: .25rem 1rem;
  background: var(--c1);
  border: 1px solid var(--c3);
  color: black;
`

export const SectionOnboard = styled.div`
display: flex;
flex-direction: column;
gap: .75rem;
& > div {
    margin-top: .75rem;
}
`

export const ComentariosContainer = styled.div`
display: flex;
justify-content: start;
width: 100%;
margin-top: 1.25rem;
margin-bottom: 1rem;
font-size: .875rem;

div{
background: var(--c2);
padding: .5rem;
width: 100%;
}

div:not(:last-child){
    margin-bottom: .75rem;
}

section{
    max-width: 70rem;
    width: 100%;
}
`

export const ComentarioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: .125rem;
  padding-bottom: 2rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--c4);
  span{
      color: var(--Red);
      font-size: .875rem;
      margin-bottom: .4rem;
   }
`

export const SkillQuestion = styled.div`
  padding-bottom: 2rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--c4);
  div {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    span {
      color: var(--Red);
      font-size: .875rem;
      margin-bottom: .25rem;
    }
  }
  div + div {
    margin-top: 0.5rem;
  }
`

export const SkillAnswer = styled.button<ISkillAnswerProps>`
background: var(--c2);
border: 1px solid var(--c6);
border-radius: 0.25rem;
padding: .75rem 1rem;
outline: 0;
display: flex;
width: 100%;
align-items: center;
margin-top: 0.325rem;
svg {
  font-size: 1.125rem;
  background: white;
  border-radius: 50%;
  color: var(--c4);
  ${(props) =>
    props.isSelected &&
    css`
      color: var(--Azul);
    `};
}
${(props) =>
  props.isSelected &&
  css`
    background: var(--AzulOpacoBg);
  `};
span {
  margin-left: .75rem;
  color: black;
  ${(props) =>
    props.isSelected &&
    css`
      font-weight: 800;
    `};
  font-size: .875rem;
}
:hover{
  ${(props) =>
    !props.isSelected &&
    css`
      background: var(--AzulOpacoBg);
    `};
}
`

export const Subtitulo = styled.span`
font-weight: 700;
color: var(--Gray1);
`
